import { Check, Camera } from "lucide-react";
import { SIZES, SIZE_INFO, sizePrice, PRICE_NOTE } from "../lib/sizes";

export const SizeSelector = ({ product, value, onChange, testPrefix = "size" }) => (
  <div data-testid={`${testPrefix}-selector`}>
    <h3 className="font-semibold text-forest mb-1">Scegli la misura</h3>
    <p className="text-xs text-sage mb-3" data-testid={`${testPrefix}-price-note`}>{PRICE_NOTE}</p>
    <div className="grid grid-cols-3 gap-3">
      {SIZES.map((s) => {
        const info = SIZE_INFO[s];
        const active = value === s;
        return (
          <button
            key={s}
            type="button"
            onClick={() => onChange(s)}
            aria-pressed={active}
            data-testid={`${testPrefix}-option-${s}`}
            className={`relative text-left rounded-xl border p-3 transition-[border-color,background-color,transform] duration-200 hover:-translate-y-0.5 ${
              active ? "border-forest bg-forest/5 ring-1 ring-forest" : "border-cream-dark bg-white hover:border-forest/40"
            }`}
          >
            {active && <span className="absolute top-2 right-2 h-5 w-5 rounded-full bg-forest text-white flex items-center justify-center"><Check className="h-3 w-3" /></span>}
            <p className="font-medium text-forest text-sm">{info.label}</p>
            <p className={`text-[11px] leading-tight mt-0.5 flex items-center gap-1 ${info.photo ? "text-brand font-medium" : "text-sage"}`}>
              {info.photo && <Camera className="h-3 w-3" />}{info.desc}
            </p>
            <p className="font-semibold text-forest mt-2" data-testid={`${testPrefix}-price-${s}`}>€{sizePrice(product, s).toFixed(2)}</p>
            {info.pct > 0 && <p className="text-[10px] text-brand-pink font-medium">+{info.pct}%</p>}
          </button>
        );
      })}
    </div>
  </div>
);
